module.exports = __webpack_public_path__ + "img/Ilustracion.0db3fef6.gif";